// ------------------------------------
// Constants
// ------------------------------------
export const LIST_SERVICES = 'LIST_SERVICES'

// ------------------------------------
// Actions
// ------------------------------------
export function listServices (value = null) {
  return {
    type    : LIST_SERVICES,
    payload : value
  }
}

export const actions = { listServices }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LIST_SERVICES] : (state, action) => action.payload
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = []
export default function listedServicesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/listedServices.js